import { ReturnStatus } from './../class/return-status';
import { SaveStudentDetails } from './../class/SaveStudentDetails';
import { StudentevaluationService } from './../service/studentevaluation.service';
import { TypeListitem } from './../class/typelistitem';
import { StudentDetail } from './../class/StudentDetail';
import { JilabaAesED } from '../common/JilabaAesED';
import { JilabaKeyEnum } from '../common/JilabaKeyEnum';


export class StudentSave {

    saveStudentDetails: SaveStudentDetails;
    returnStatus: ReturnStatus;

    constructor(public StudentService: StudentevaluationService) {
        this.saveStudentDetails = new SaveStudentDetails();
    }


    getBeforHashStr(studentdetail: StudentDetail){
        studentdetail.clgcode=studentdetail.clgcode?studentdetail.clgcode:"";
        studentdetail.mobno=studentdetail.mobno?studentdetail.mobno:"";
        studentdetail.email=studentdetail.email?studentdetail.email:"";
        studentdetail.dateofbirth=studentdetail.dateofbirth?studentdetail.dateofbirth:"";
        studentdetail.yearofpas=studentdetail.yearofpas?studentdetail.yearofpas:"";
        studentdetail.clgrollno=studentdetail.clgrollno?studentdetail.clgrollno:"";
        studentdetail.fathersname=studentdetail.fathersname?studentdetail.fathersname:"";
        studentdetail.gender=studentdetail.gender?studentdetail.gender:"";
        studentdetail.mothersname=studentdetail.mothersname?studentdetail.mothersname:"";
        studentdetail.pincode=studentdetail.pincode?studentdetail.pincode:"";
        studentdetail.studname=studentdetail.studname?studentdetail.studname:"";
        studentdetail.studno=studentdetail.studno?studentdetail.studno:"";
        studentdetail.abroad=studentdetail.abroad?studentdetail.abroad:"";
        studentdetail.cgpa=studentdetail.cgpa?studentdetail.cgpa:0;
        studentdetail.tnthmark=studentdetail.tnthmark?studentdetail.tnthmark:0;
        studentdetail.tnthmaths=studentdetail.tnthmaths?studentdetail.tnthmaths:0;
        studentdetail.twelthmark=studentdetail.twelthmark?studentdetail.twelthmark:0;
        studentdetail.twelthmaths=studentdetail.twelthmaths?studentdetail.twelthmaths:0;
        studentdetail.clgtype=studentdetail.clgtype?studentdetail.clgtype:"";
        studentdetail.clgname=studentdetail.clgname?studentdetail.clgname:"";
        studentdetail.clgAddress=studentdetail.clgAddress?studentdetail.clgAddress:"";

        let str=studentdetail.clgcode + studentdetail.mobno + studentdetail.email+studentdetail.dateofbirth+studentdetail.yearofpas+studentdetail.clgrollno+studentdetail.fathersname+studentdetail.gender+studentdetail.mothersname+studentdetail.pincode+studentdetail.studname+studentdetail.studno+studentdetail.abroad+studentdetail.cgpa
        +studentdetail.tnthmark+studentdetail.tnthmaths+studentdetail.twelthmark+studentdetail.twelthmaths
        +studentdetail.clgname+studentdetail.clgAddress;

        return str;
    }
    
    async stusave(studentdetail: StudentDetail, selecteddetails: Array<TypeListitem>): Promise<ReturnStatus> {
        this.saveStudentDetails.studentDetail = studentdetail;
        this.saveStudentDetails.selectedFamiliar = selecteddetails;
        this.saveStudentDetails.hashData = JilabaAesED.Encrypt(this.getBeforHashStr(studentdetail), JilabaKeyEnum.CommonKey);
        await this.StudentService.savestudent(this.saveStudentDetails).then(data => {
            this.returnStatus = data;
            if (this.returnStatus.status === true) {
                this.saveStudentDetails = new SaveStudentDetails();
                studentdetail = new StudentDetail();
                selecteddetails = new Array<TypeListitem>();
            } else {
                this.saveStudentDetails.status = this.returnStatus.description;
            }
        });
        return this.returnStatus;
    }

    async stuupdate(studentdetail: StudentDetail, selecteddetails: Array<TypeListitem>): Promise<ReturnStatus> {
        this.saveStudentDetails.studentDetail = studentdetail;
        this.saveStudentDetails.selectedFamiliar = selecteddetails;
        this.saveStudentDetails.hashData = JilabaAesED.Encrypt(this.getBeforHashStr(studentdetail), JilabaKeyEnum.CommonKey);
        await this.StudentService.updatestudent(this.saveStudentDetails).then(data => {
            this.returnStatus = data;
            if (this.returnStatus.status === true) {
                this.saveStudentDetails = new SaveStudentDetails();
                studentdetail = new StudentDetail();
                selecteddetails = new Array<TypeListitem>();
            }
        });
        return this.returnStatus;
    }

}
